import React, { Component } from 'react';
import PropTypes from 'prop-types';

class SearchInput extends Component {

  state = {
    text: '',
  }

  onInputChange = (e, onSearch, transform) => {
    const inputValue = e.target.value;
    this.handleTextChanged(inputValue, onSearch);
  };

  handleTextChanged = (inputValue) => {
    const { onSearch, transform } = this.props;
    const text = transform ? transform(inputValue) : inputValue.trim();
    this.setState({ text: text });
    if (onSearch) {
      onSearch(text);
    }
  }

  clear = () => {
    this.handleTextChanged('');
  }

  render = () => {
    const { text } = this.state;
    return (
      <div style={{position: 'relative'}}>
        <input type="text" className="filter form-control form-control-sm" value={text} onChange={this.onInputChange} />
        {!!text && (<i className='material-icons' style={{ cursor: 'pointer', position: 'absolute', left: '90%' }} onClick={this.clear}>clear</i>)}
      </div>
    )
  };
}

SearchInput.propTypes = {
  transform: PropTypes.func,
  onSearch: PropTypes.func
};

export default SearchInput;


// WEBPACK FOOTER //
// ./App/components/modules/measurement-validator/common/search-input.js